import isEmpty from "lodash-es/isEmpty";
import truncate from "lodash-es/truncate";

export const isStringEmpty = (str) => {
  return str == null || str === "" || str === "-- NONE --" || str.trim() === "";
};

export const isEmptyDefault = (str, defaultStr) => {
  if (isStringEmpty(str)) {
    return defaultStr;
  }
  return str;
};

export const getSubDomain = () => {
  const host = window.location.host;
  let subdomain = host.split(".")[0];
  subdomain = subdomain.replace("https://", "");
  subdomain = subdomain.replace("http://", "");
  subdomain = subdomain.replace(":3003", "");
  return subdomain;
};

export const isSubDomainKnown = () => {
  const subdomain = getSubDomain();
  if (subdomain.startsWith("localhost") || subdomain.startsWith("plus")) {
    return false;
  }

  return true;
};

export const paddy = (num, padlen, padchar) => {
  let pad_char = typeof padchar !== "undefined" ? padchar : "0";
  let pad = new Array(1 + padlen).join(pad_char);
  return (pad + num).slice(-pad.length);
};

export const formatHourMinute = (hour, minute) => {
  if (hour > 12) hour -= 12;
  return `${paddy(hour, 2, "0")}:${paddy(minute, 2, "0")}`;
};

export const hashString = async (str) => {
  const utf8 = new TextEncoder().encode(str);
  const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((bytes) => bytes.toString(16).padStart(2, "0"))
    .join("");
  return hashHex;
};

export const millisToMinutesAndSeconds = (millis) => {
  let minutes = Math.floor(millis / 60000);
  let seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + "m " + (seconds < 10 ? "0" : "") + seconds + "s";
};

export const secondsToMinutesAndSeconds = (inputSeconds) => {
  let minutes = Math.floor(inputSeconds / 60);
  let adjustedSeconds = (inputSeconds % 60).toFixed(0);
  return (
    minutes + "m " + (adjustedSeconds < 10 ? "0" : "") + adjustedSeconds + "s"
  );
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const evalNa = (str) => {
  if (isEmpty(str)) {
    return "N/A";
  }
  return str;
};

export const addEllipsis = (str, maxLength) => {
  return truncate(str, {
    length: maxLength,
    omission: "...",
  });
};

export const getHM = (hour, minute) => {
  return `${paddy(hour, 2, "0")}:${paddy(minute, 2, "0")}`;
};

export const getHMTime = (hour, minute) => {
  let fixedHour = hour;
  if (fixedHour > 12) {
    fixedHour -= 12;
  }
  return `${paddy(fixedHour, 2, "0")}:${paddy(minute, 2, "0")} ${
    hour > 12 ? "PM" : "AM"
  }`;
};

export const isUUID = (str) => {
  // Matches UUID v1–v5
  str = str.toLowerCase();
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

export const interpolate = (str, data) => {
  return str.replace(/\${(.*?)}/g, (_, key) => data[key.trim()] ?? "");
};

export const getHM2 = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);

  const parts = [];
  if (hrs > 0) parts.push(`${hrs}h`);
  if (mins > 0) parts.push(`${mins}m`);

  return parts.join(" ");
};


export const getHMS = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const parts = [];
  if (hrs > 0) parts.push(`${hrs}h`);
  if (mins > 0) parts.push(`${mins}m`);
  if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);

  return parts.join(" ");
};

export const getMS = (seconds) => {
  const totalMins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  const parts = [];
  if (totalMins > 0)
    parts.push(`${totalMins}m`);
  if (secs > 0 || parts.length === 0)
    parts.push(`${secs}s`);

  return parts.join(" ");
};

export const isString = (value) => {
  return typeof value === "string";
};


export const isValidUrl = (string) => {
  try {
    new URL(string);
    return true;
  } catch {
    return false;
  }
}